import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { BaseService } from './baseservice';
import { firstValueFrom, Observable } from 'rxjs';
import { GamePageViewModel, GameDetailsViewModel, DivisionGameFilterFlatModel, GameFilter } from '../models/GameModels';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JsonGameTickerResult } from '../models/ExternalSourceModels';
import moment from 'moment';
import { PlayerListDetailsViewModel } from '../models/PlayerListModels';
import { GameRatingDetailsViewModel } from '../models/gamerating';


@Injectable({
  providedIn: 'root'
})
export class GameService extends BaseService {
   private divisionFilterSignal: WritableSignal<DivisionGameFilterFlatModel[]> = signal([]);
   constructor(private http: HttpClient) {
      super();
     }

   getGames(): Observable<GamePageViewModel>{

    let ret = this.http.get<GamePageViewModel>(this.rootUrl + '/api/games/filtered' );
    return ret;
   }

   getGamesFiltered(filter: GameFilter[]): Observable<GamePageViewModel>{

      let ret = this.http.post<GamePageViewModel>(this.rootUrl + '/api/games/extendedfilter', filter);
      return ret;
   }


   getGamesByDate(fromDate: Date, toDate: Date): Observable<GamePageViewModel> {

      let ret = this.http.get<GamePageViewModel>(this.rootUrl + '/api/GetGamesFromDateToDate?DateFrom=' + moment(fromDate).format("yyyy-MM-DD") + '&DateTo=' + moment(toDate).format("yyyy-MM-DD"));
      return ret;
     }
   getPastGames(): Observable<GamePageViewModel>{

      let ret = this.http.get<GamePageViewModel>(this.rootUrl + '/api/gamespast/filtered' );
      return ret;
     }

     getPastGamesFiltered(filter: GameFilter[]): Observable<GamePageViewModel>{

      let ret = this.http.post<GamePageViewModel>(this.rootUrl + '/api/gamespast/extendedfilter', filter);
      return ret;
     }

   getGameDetails(GameId: string): Observable<GameDetailsViewModel>{

    let ret = this.http.get<GameDetailsViewModel>(this.rootUrl + '/api/game/' + GameId );
    return ret;
   }

   getGameDetailsSimple(GameId: string): Observable<GameDetailsViewModel>{

      let ret = this.http.get<GameDetailsViewModel>(this.rootUrl + '/api/game/simple/' + GameId );
      return ret;
     }


   getGameStatistics(GameId: string): Observable<GameDetailsViewModel>{
    let ret = this.http.get<GameDetailsViewModel>(this.rootUrl + '/api/game/' + GameId + '/GetStatistics' );
    return ret;
   }

   getExternalGameStatistics(GameId:string){
      let ret = this.http.get<JsonGameTickerResult>(this.rootUrl + '/api/game/' + GameId + '/ImportStatistics')
      return ret;
   }

   getDivisionFilter(){
    let ret = this.http.get<DivisionGameFilterFlatModel[]>(this.rootUrl + '/api/game/filter')
    return ret;
   }

   async getDivisionFilterSignals(): Promise<WritableSignal<DivisionGameFilterFlatModel[]>> {
      const data = await firstValueFrom(
        this.http.get<DivisionGameFilterFlatModel[]>(this.rootUrl + '/api/game/filter')
      );
      this.divisionFilterSignal.set(data);
      return this.divisionFilterSignal;
    }

   setDivisionFilter( DivisionIds: string[]){
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json'});
    return this.http.post(this.rootUrl + '/api/game/filter', DivisionIds, { headers: reqHeader });
   }

       async setHideOldDivisionsFilter( hideOldDivisions: boolean){
         var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json'});
         return this.http.post(this.rootUrl + '/api/game/setHideOldDivisionsFilter', hideOldDivisions, { headers: reqHeader });
        }
      
   getHideOldDivisionsFilter(){
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json'});
      return this.http.get<boolean>(this.rootUrl + '/api/game/getHideOldDivisionsFilter');
  
     }

   getGameRankingsForPlayerAndSeason_GoogleCharts(PlayerId: string, SeasonId: string): Observable<any>{
      return  this.http.get<any>(this.rootUrl + '/api/load/player/' + PlayerId + '/' + SeasonId + '/gameranking/chartdata');
     }

   getGameRankingsForPlayer_GoogleCharts(PlayerId: string): Observable<any>{
    return  this.http.get<any>(this.rootUrl + '/api/load/player/' + PlayerId + '/gameranking/chartdata');
   }
/*    getGamesParameterGroupForPlayer_GoogleCharts(PlayerId: string, ParameterGroupId: string): Observable<any>{
      //Get ganes with parametergroup values to generate chart for parameters in group over a time period
      return  this.http.get<any>(this.rootUrl + '/api/load/player/' + PlayerId + '/games/parametergroup/' + ParameterGroupId + '/parameters/chartdata');
   }
 */
   getGamesParameterGroupForPlayerAndSeason_GoogleCharts(PlayerId: string, ParameterGroupId: number, SeasonId: string): Observable<any>{
      //Get ganes with parametergroup values to generate chart for parameters in group over a time period
      return  this.http.get<any>(this.rootUrl + '/api/load/player/' + PlayerId + '/' + SeasonId + '/games/parametergroup/' + ParameterGroupId + '/parameters/chartdata');
   }

   updateGameGrade(GameId: string, Grade: number, TeamId: string, PlayerId: string): Observable<any>{
      var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json'});
      return this.http.post(this.rootUrl + '/api/load/game/grade/' + GameId + '/team/' + TeamId + "/player/" + PlayerId, Grade,  { headers: reqHeader });
   }
  
   getGradesPerGame(GameId: string): Observable<GameRatingDetailsViewModel>{
      return this.http.get<GameRatingDetailsViewModel>(this.rootUrl + '/api/game/' + GameId + "/grades");
   }

   getGradesPerGameForUser(GameId: string): Observable<GameRatingDetailsViewModel>{
      return this.http.get<GameRatingDetailsViewModel>(this.rootUrl + '/api/game/' + GameId + "/gradesforuser");
   }
}
